import { makeStyles } from '@material-ui/core/styles';

//Estilo para el llenado de la pantalla
export const useStylesAnchor = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  }
}));

//Estilos Generales
export const useStylesGeneral = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    margin: 0
  },
  modal: {
    width: '100%'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    margin: 13,
    width: 200,
  },
  textFieldFull: {
    margin: 13
  },
  formControl: {
    margin: 13,
    width: 200,
  },
  selectEmpty: {
    margin: 13,
    width: 200,
  },
  button: {
    color: theme.palette.primary,
    marginTop: '7px',
    backgroundColor: '#00549F',
    '&:hover': {
      backgroundColor: '#FFA100',
    },
  },
  buttonGrid: {
    color: '#ffffff',
    backgroundColor: '#00549F',
    '&:hover': {
      backgroundColor: '#FFA100',
    },
  },
  buttonlink: {
    color: theme.palette.primary,
    marginTop: '7px'
  },
  radio: {
    backgroundColor: '#00549F'
  },
  font: {
    fontFamily: 'News Gothic MT'
  }
}));

//Alert message
export const AlertStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    }
  },
}));

//Botones 
export const FileUploadStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
  button: {
    color: '#ffffff',
    backgroundColor: '#00549F',
    '&:hover': {
      backgroundColor: '#FFA100',
    },
  }
}));

//FileUpload S3 
export const FileUploadS3Styles = makeStyles(() => ({
  root: { flexGrow: 1 },
  container: { display: 'flex', flexWrap: 'wrap', justifyContent: 'center' },
  input: { width: "100%" },
  button: {
    color: '#ffffff',
    backgroundColor: '#00549F',
    '&:hover': {
      backgroundColor: '#FFA100',
    },
  }
}));

//progress bar
export const ProgressbarStyles = makeStyles({
  root: {
    width: '98%',
    margin: 13,
    flexWrap: 1,
    height: '100%',
  },
});

//TextField Multiline
export const useStylesMultiline = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    margin: 13,
    width: 300,
  },
  button: {
    color: '#ffffff',
    backgroundColor: '#00549F',
    '&:hover': {
      backgroundColor: '#FFA100',
    },
  }
}));

//DropDownlist
export const useStylesDropDownList = makeStyles(() => ({
  formControl: {
    margin: 13,
    width: 300,
  },
  selectEmpty: {
    margin: 13,
    width: 300,
  },
}));

//Acordeon
export const useStylesAccordion = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(17),
    width: '33%',
    color: '#00549F',
    backgroundColor: '#fff',
    flexShrink: 0,
    textAlign: 'left'
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(17),
    color: '#98999b',
    backgroundColor: '#fff',
    verticalAlign: 'middle'
  },
}));

//centrado de pagina
export const StylesStretch = makeStyles(() => ({
  container: {
    flex: 1,
    flexDirection: "column"
  },
  image: {
    flex: 1,
    resizeMode: "cover",
    justifyContent: "center"
  },
  text: {
    color: "white",
    fontSize: 42,
    fontWeight: "bold",
    textAlign: "center",
    backgroundColor: "#000000a0"
  }
}));

// Material Table
export const MaterialGrid = {
  Body: {
    emptyDataSourceMessage: "No hay registros que mostrar",
    addTooltip: "Agregar Registro",
    deleteTooltip: "Borrar",
    editTooltip: "Editar",
    filterRow: {
      filterTooltip: "Filtrar",
    },
    editRow: {
      deleteText: "¿Quieres borrar este registro?",
      cancelTooltip: "Cancelar",
      saveTooltip: "Guardar",
    },
  },
  Group: {
    placeholder: "Agrupar por ...",
    groupedBy: "Agrupar por:"
  },
  Pagination: {
    labelDisplayedRows: "{from}-{to} de {count}",
    labelRowsSelect: "Registros",
    labelRowsPerPage: "Registros por página:",
    firstAriaLabel: "Primer página",
    firstTooltip: "Primer página",
    previousAriaLabel: "Página anterior",
    previousTooltip: "Página anterior",
    nextAriaLabel: "Siguiente página",
    nextTooltip: "Siguiente página",
    lastAriaLabel: "Última página",
    lastTooltip: "Última página",
  },
  Toolbar: {
    addRemoveColumns: "Agregar o quitar columnas",
    nRowsSelected: "{0} registro(s) seleccionados(s)",
    showColumnsTitle: "Ver columnas",
    showColumnsAriaLabel: "Ver columnas",
    exportTitle: "Exportar Tabla a Excel o PDF",
    exportAriaLabel: "Exportar",
    exportName: "Exportar en CSV",
    searchTooltip: "Filtrar",
    searchPlaceholder: "Filtrar"
  },
  headerStyle: {
    backgroundColor: '#FFA100',
    color: "#FFF",
  }
};

